<div accordion #main>
    <div #header tabindex="0" (click)="toggle($event)" class="ig-according-header" [class.ripple]="!disabled" [class.filtering]="isFiltering"
         [class.ig-according-expanded]="expanded" [class.ig-according-folded]="!expanded&&!disabled" role="button"
         aria-label="expandable area" [attr.aria-controls]="id" [attr.aria-expanded]="expanded">
        <mat-icon *ngIf="!!icon" class="notranslate" translate="no" (click)="iconClick($event)" matTooltip="{{iconTooltip||''}}">{{icon}}</mat-icon>
        <span>{{title}}</span>
        <mat-icon *ngIf="!!icon2" class="accordion-icon2" (click)="icon2Click($event)" matTooltip="get {{icon2}}">{{icon2}}</mat-icon>
        <mat-icon arrow *ngIf="!disabled&&!isFiltering" class="notranslate" translate="no">{{expanded ? 'expand_more' : 'chevron_left'}}</mat-icon>
        <mat-icon arrow *ngIf="!disabled&&isFiltering" class="notranslate" translate="no" (click)="clearFilter($event)">clear</mat-icon>
    </div>
    <div [attr.id]="id" class="ig-according-content" [ngStyle]="{'display':display,'maxHeight':maxHeight?(maxHeight+'px'):'unset'}">
        <ng-content></ng-content>
    </div>

</div>




// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/accordion/accordion.component.html